import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Livingetc: Site = {
  id: 'livingetc',
  logo: 'svg/livingetc.svg',
  label: 'Livingetc',
  analyticsName: 'livingetc',
  hostname: 'livingetc.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
